<script lang="ts">
    import Content from './Content.svelte'
    import Footer from './Footer.svelte'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher();
</script>

<Content>
    <slot/>
</Content>
<Footer>
    <div style="flex:1;"></div>
    <button on:click={() => dispatch("done")}>Suivant →</button>
</Footer>